import React, { useState } from 'react';
import { InitDataService } from '../scripts/initData';
import { InitElectionsService } from '../scripts/initElections';
import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const InitPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const handleInit = async () => {
    setLoading(true);
    setMessage('Initialisation en cours...');
    
    try {
      // Initialiser les utilisateurs
      await InitDataService.initAll();
      setMessage('Utilisateurs créés, initialisation des élections...');
      
      // Initialiser les élections
      await InitElectionsService.initAllElections();
      setMessage('Initialisation terminée avec succès !');
      setSuccess(true);
    } catch (error) {
      setMessage('Erreur lors de l\'initialisation');
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Initialisation ASPROCOM Vote
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Créer les comptes admin et membre de test
          </p>
        </div>
        
        <div className="mt-8 space-y-6">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="text-sm font-medium text-blue-800 mb-2">
              Comptes qui seront créés :
            </h3>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>👑 <strong>Admin:</strong> admin@asprocom.com / asprocom2024!</li>
              <li>👤 <strong>Membre:</strong> membre@asprocom.com / membre2024!</li>
              <li>🗳️ <strong>8 Élections</strong> avec candidats prédéfinis</li>
            </ul>
          </div>
          
          {message && (
            <div className={`rounded-md p-4 ${
              success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'
            }`}>
              <div className="flex">
                <div className="flex-shrink-0">
                  {success ? (
                    <CheckCircleIcon className="h-5 w-5 text-green-400" />
                  ) : (
                    <ExclamationTriangleIcon className="h-5 w-5 text-red-400" />
                  )}
                </div>
                <div className="ml-3">
                  <p className={`text-sm font-medium ${
                    success ? 'text-green-800' : 'text-red-800'
                  }`}>
                    {message}
                  </p>
                </div>
              </div>
            </div>
          )}
          
          <button
            onClick={handleInit}
            disabled={loading}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            ) : (
              'Initialiser les données'
            )}
          </button>
          
          <div className="text-center">
            <p className="text-sm text-gray-500">
              Cette page ne doit être utilisée qu'une seule fois pour l'initialisation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InitPage;
